/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bishop/collections/v1/api.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  AssetFolderServiceBatchDeleteFoldersBody,
  AssetFolderServiceBatchDownloadFoldersBody,
  AssetFolderServiceBatchDuplicateFoldersBody,
  AssetFolderServiceBatchMoveFoldersBody,
  AssetFolderServiceDuplicateFolderBody,
  AssetFolderServiceMoveFolderBody,
  AssetServiceBatchDeleteAssetsBody,
  AssetServiceBatchDownloadAssetsBody,
  AssetServiceBatchDuplicateAssetsBody,
  AssetServiceBatchMoveAssetsBody,
  AssetServiceCreateAssetBody,
  AssetServiceDuplicateAssetBody,
  AssetServiceGenerateAssetDownloadUrlBody,
  AssetServiceMoveAssetBody,
  AssetServiceRefreshAssetContentBody,
  CollectionRowsServiceBatchDeleteCollectionRowsBody,
  CollectionRowsServiceBatchInsertCollectionRowsBody,
  CollectionRowsServiceExportCollectionBody,
  CollectionRowsServiceImportCollectionBody,
  CollectionRowsServiceListCollectionRowsBody,
  CollectionsServiceAddCollectionFieldBody,
  CollectionsServiceCreateCollectionBody,
  CollectionsServiceDeleteCollectionFieldBody,
  CollectionsServicePublishCollectionBody,
  CollectionsServiceUpdateCollectionFieldBody,
  CollectionsServiceUpdateCollectionSchemaBody,
  CreateFolderParams,
  DeleteAsset200,
  DeleteCollection200,
  DeleteCollectionRow200,
  DeleteCollectionRowParams,
  DeleteFolder200,
  DeleteFolderParams,
  GetCollectionParams,
  GetCollectionRowParams,
  GetCollectionSchemaParams,
  InsertCollectionRowBody,
  InsertCollectionRowParams,
  ListAssetsParams,
  ListCollectionsParams,
  ListFoldersParams,
  RpcStatus,
  UpdateAssetBody,
  UpdateCollectionBody,
  UpdateCollectionRowBody,
  UpdateCollectionRowParams,
  UpdateFolderBody,
  V1Asset,
  V1BatchDeleteAssetsResponse,
  V1BatchDeleteCollectionRowsResponse,
  V1BatchDeleteFoldersResponse,
  V1BatchDownloadAssetsResponse,
  V1BatchDownloadFoldersResponse,
  V1BatchDuplicateAssetsResponse,
  V1BatchDuplicateFoldersResponse,
  V1BatchInsertCollectionRowsResponse,
  V1BatchMoveAssetsResponse,
  V1BatchMoveFoldersResponse,
  V1BatchUpdateCollectionRowsRequest,
  V1BatchUpdateCollectionRowsResponse,
  V1Collection,
  V1CollectionSchema,
  V1DeleteCollectionRowsByFilterRequest,
  V1DeleteCollectionRowsByFilterResponse,
  V1ExportCollectionResponse,
  V1Folder,
  V1GenerateAssetDownloadUrlResponse,
  V1GetCollectionRowResponse,
  V1GetFolderTreeResponse,
  V1ImportCollectionResponse,
  V1InsertCollectionRowResponse,
  V1ListAssetsResponse,
  V1ListCollectionRowsResponse,
  V1ListCollectionTagsResponse,
  V1ListCollectionsResponse,
  V1ListFoldersResponse,
  V1ListWorkspaceTagsResponse,
  V1PublishCollectionResponse,
  V1UpdateCollectionRowResponse,
  V1UpdateCollectionRowsByFilterRequest,
  V1UpdateCollectionRowsByFilterResponse,
} from '../../models';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

/**
 * @summary List assets in a workspace, optionally filtered by folder.
 */
export const listAssets = (
  organization: string,
  workspace: string,
  params?: ListAssetsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListAssetsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListAssetsQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListAssetsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAssetsQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssets>>> = ({
    signal,
  }) =>
    listAssets(organization, workspace, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAssets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAssetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAssets>>
>;
export type ListAssetsQueryError = AxiosError<RpcStatus>;

export function useListAssets<
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListAssetsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssets>>,
          TError,
          Awaited<ReturnType<typeof listAssets>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAssets<
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssets>>,
          TError,
          Awaited<ReturnType<typeof listAssets>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAssets<
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List assets in a workspace, optionally filtered by folder.
 */

export function useListAssets<
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListAssetsQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Register a new asset by linking an already-uploaded Bishop file to
workspace/folder/tag metadata. See upload flow above.
 */
export const createAsset = (
  organization: string,
  workspace: string,
  assetServiceCreateAssetBody: AssetServiceCreateAssetBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Asset>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets`,
    assetServiceCreateAssetBody,
    options,
  );
};

export const getCreateAssetMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAsset>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AssetServiceCreateAssetBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAsset>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetServiceCreateAssetBody;
  },
  TContext
> => {
  const mutationKey = ['createAsset'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAsset>>,
    {
      organization: string;
      workspace: string;
      data: AssetServiceCreateAssetBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return createAsset(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAsset>>
>;
export type CreateAssetMutationBody = AssetServiceCreateAssetBody;
export type CreateAssetMutationError = AxiosError<RpcStatus>;

/**
 * @summary Register a new asset by linking an already-uploaded Bishop file to
workspace/folder/tag metadata. See upload flow above.
 */
export const useCreateAsset = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAsset>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AssetServiceCreateAssetBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAsset>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetServiceCreateAssetBody;
  },
  TContext
> => {
  const mutationOptions = getCreateAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get asset metadata by resource name.
 */
export const getAsset = (
  organization: string,
  workspace: string,
  asset: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Asset>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets/${asset}`,
    options,
  );
};

export const getGetAssetQueryKey = (
  organization?: string,
  workspace?: string,
  asset?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets/${asset}`,
  ] as const;
};

export const getGetAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAsset>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  asset: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssetQueryKey(organization, workspace, asset);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAsset>>> = ({
    signal,
  }) => getAsset(organization, workspace, asset, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && asset),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetAssetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAsset>>
>;
export type GetAssetQueryError = AxiosError<RpcStatus>;

export function useGetAsset<
  TData = Awaited<ReturnType<typeof getAsset>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  asset: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAsset>>,
          TError,
          Awaited<ReturnType<typeof getAsset>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAsset<
  TData = Awaited<ReturnType<typeof getAsset>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  asset: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAsset>>,
          TError,
          Awaited<ReturnType<typeof getAsset>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAsset<
  TData = Awaited<ReturnType<typeof getAsset>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  asset: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get asset metadata by resource name.
 */

export function useGetAsset<
  TData = Awaited<ReturnType<typeof getAsset>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  asset: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssetQueryOptions(
    organization,
    workspace,
    asset,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete an asset (removes metadata and the underlying Bishop file).
 */
export const deleteAsset = (
  organization: string,
  workspace: string,
  asset: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteAsset200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets/${asset}`,
    options,
  );
};

export const getDeleteAssetMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAsset>>,
    TError,
    { organization: string; workspace: string; asset: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAsset>>,
  TError,
  { organization: string; workspace: string; asset: string },
  TContext
> => {
  const mutationKey = ['deleteAsset'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAsset>>,
    { organization: string; workspace: string; asset: string }
  > = props => {
    const { organization, workspace, asset } = props ?? {};

    return deleteAsset(organization, workspace, asset, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAsset>>
>;

export type DeleteAssetMutationError = AxiosError<RpcStatus>;

/**
 * @summary Delete an asset (removes metadata and the underlying Bishop file).
 */
export const useDeleteAsset = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAsset>>,
      TError,
      { organization: string; workspace: string; asset: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAsset>>,
  TError,
  { organization: string; workspace: string; asset: string },
  TContext
> => {
  const mutationOptions = getDeleteAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update mutable asset fields: display_name, description, tags.
Use MoveAsset to change the folder.
Include "tags" in update_mask to replace or clear tags (see UpdateAssetRequest).
 */
export const updateAsset = (
  organization: string,
  workspace: string,
  asset: string,
  updateAssetBody: NonReadonly<UpdateAssetBody>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Asset>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets/${asset}`,
    updateAssetBody,
    options,
  );
};

export const getUpdateAssetMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAsset>>,
    TError,
    {
      organization: string;
      workspace: string;
      asset: string;
      data: NonReadonly<UpdateAssetBody>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAsset>>,
  TError,
  {
    organization: string;
    workspace: string;
    asset: string;
    data: NonReadonly<UpdateAssetBody>;
  },
  TContext
> => {
  const mutationKey = ['updateAsset'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAsset>>,
    {
      organization: string;
      workspace: string;
      asset: string;
      data: NonReadonly<UpdateAssetBody>;
    }
  > = props => {
    const { organization, workspace, asset, data } = props ?? {};

    return updateAsset(organization, workspace, asset, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAsset>>
>;
export type UpdateAssetMutationBody = NonReadonly<UpdateAssetBody>;
export type UpdateAssetMutationError = AxiosError<RpcStatus>;

/**
 * @summary Update mutable asset fields: display_name, description, tags.
Use MoveAsset to change the folder.
Include "tags" in update_mask to replace or clear tags (see UpdateAssetRequest).
 */
export const useUpdateAsset = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAsset>>,
      TError,
      {
        organization: string;
        workspace: string;
        asset: string;
        data: NonReadonly<UpdateAssetBody>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAsset>>,
  TError,
  {
    organization: string;
    workspace: string;
    asset: string;
    data: NonReadonly<UpdateAssetBody>;
  },
  TContext
> => {
  const mutationOptions = getUpdateAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Duplicate an asset — creates a server-side file copy and a new asset record.
The new asset's display_name is prefixed "Copy of "; the original is unchanged.
Returns the newly created Asset.
 */
export const duplicateAsset = (
  organization: string,
  workspace: string,
  asset: string,
  assetServiceDuplicateAssetBody: AssetServiceDuplicateAssetBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Asset>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets/${asset}:duplicate`,
    assetServiceDuplicateAssetBody,
    options,
  );
};

export const getDuplicateAssetMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateAsset>>,
    TError,
    {
      organization: string;
      workspace: string;
      asset: string;
      data: AssetServiceDuplicateAssetBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateAsset>>,
  TError,
  {
    organization: string;
    workspace: string;
    asset: string;
    data: AssetServiceDuplicateAssetBody;
  },
  TContext
> => {
  const mutationKey = ['duplicateAsset'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateAsset>>,
    {
      organization: string;
      workspace: string;
      asset: string;
      data: AssetServiceDuplicateAssetBody;
    }
  > = props => {
    const { organization, workspace, asset, data } = props ?? {};

    return duplicateAsset(organization, workspace, asset, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateAsset>>
>;
export type DuplicateAssetMutationBody = AssetServiceDuplicateAssetBody;
export type DuplicateAssetMutationError = AxiosError<RpcStatus>;

/**
 * @summary Duplicate an asset — creates a server-side file copy and a new asset record.
The new asset's display_name is prefixed "Copy of "; the original is unchanged.
Returns the newly created Asset.
 */
export const useDuplicateAsset = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof duplicateAsset>>,
      TError,
      {
        organization: string;
        workspace: string;
        asset: string;
        data: AssetServiceDuplicateAssetBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof duplicateAsset>>,
  TError,
  {
    organization: string;
    workspace: string;
    asset: string;
    data: AssetServiceDuplicateAssetBody;
  },
  TContext
> => {
  const mutationOptions = getDuplicateAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generate a presigned download URL for an asset.
Delegates to Bishop FilesService.GenerateDownloadUrl.
 */
export const generateAssetDownloadUrl = (
  organization: string,
  workspace: string,
  asset: string,
  assetServiceGenerateAssetDownloadUrlBody: AssetServiceGenerateAssetDownloadUrlBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GenerateAssetDownloadUrlResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets/${asset}:generateDownloadUrl`,
    assetServiceGenerateAssetDownloadUrlBody,
    options,
  );
};

export const getGenerateAssetDownloadUrlMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateAssetDownloadUrl>>,
    TError,
    {
      organization: string;
      workspace: string;
      asset: string;
      data: AssetServiceGenerateAssetDownloadUrlBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateAssetDownloadUrl>>,
  TError,
  {
    organization: string;
    workspace: string;
    asset: string;
    data: AssetServiceGenerateAssetDownloadUrlBody;
  },
  TContext
> => {
  const mutationKey = ['generateAssetDownloadUrl'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateAssetDownloadUrl>>,
    {
      organization: string;
      workspace: string;
      asset: string;
      data: AssetServiceGenerateAssetDownloadUrlBody;
    }
  > = props => {
    const { organization, workspace, asset, data } = props ?? {};

    return generateAssetDownloadUrl(
      organization,
      workspace,
      asset,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateAssetDownloadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateAssetDownloadUrl>>
>;
export type GenerateAssetDownloadUrlMutationBody =
  AssetServiceGenerateAssetDownloadUrlBody;
export type GenerateAssetDownloadUrlMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generate a presigned download URL for an asset.
Delegates to Bishop FilesService.GenerateDownloadUrl.
 */
export const useGenerateAssetDownloadUrl = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateAssetDownloadUrl>>,
      TError,
      {
        organization: string;
        workspace: string;
        asset: string;
        data: AssetServiceGenerateAssetDownloadUrlBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateAssetDownloadUrl>>,
  TError,
  {
    organization: string;
    workspace: string;
    asset: string;
    data: AssetServiceGenerateAssetDownloadUrlBody;
  },
  TContext
> => {
  const mutationOptions = getGenerateAssetDownloadUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Move an asset to a different folder (or to the workspace root).
 */
export const moveAsset = (
  organization: string,
  workspace: string,
  asset: string,
  assetServiceMoveAssetBody: AssetServiceMoveAssetBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Asset>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets/${asset}:move`,
    assetServiceMoveAssetBody,
    options,
  );
};

export const getMoveAssetMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveAsset>>,
    TError,
    {
      organization: string;
      workspace: string;
      asset: string;
      data: AssetServiceMoveAssetBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof moveAsset>>,
  TError,
  {
    organization: string;
    workspace: string;
    asset: string;
    data: AssetServiceMoveAssetBody;
  },
  TContext
> => {
  const mutationKey = ['moveAsset'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof moveAsset>>,
    {
      organization: string;
      workspace: string;
      asset: string;
      data: AssetServiceMoveAssetBody;
    }
  > = props => {
    const { organization, workspace, asset, data } = props ?? {};

    return moveAsset(organization, workspace, asset, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MoveAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof moveAsset>>
>;
export type MoveAssetMutationBody = AssetServiceMoveAssetBody;
export type MoveAssetMutationError = AxiosError<RpcStatus>;

/**
 * @summary Move an asset to a different folder (or to the workspace root).
 */
export const useMoveAsset = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof moveAsset>>,
      TError,
      {
        organization: string;
        workspace: string;
        asset: string;
        data: AssetServiceMoveAssetBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof moveAsset>>,
  TError,
  {
    organization: string;
    workspace: string;
    asset: string;
    data: AssetServiceMoveAssetBody;
  },
  TContext
> => {
  const mutationOptions = getMoveAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Refresh the asset's cached content fields — size_bytes, mime_type,
update_time — from its backing file.
 */
export const refreshAssetContent = (
  organization: string,
  workspace: string,
  asset: string,
  assetServiceRefreshAssetContentBody: AssetServiceRefreshAssetContentBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Asset>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets/${asset}:refreshContent`,
    assetServiceRefreshAssetContentBody,
    options,
  );
};

export const getRefreshAssetContentMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshAssetContent>>,
    TError,
    {
      organization: string;
      workspace: string;
      asset: string;
      data: AssetServiceRefreshAssetContentBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshAssetContent>>,
  TError,
  {
    organization: string;
    workspace: string;
    asset: string;
    data: AssetServiceRefreshAssetContentBody;
  },
  TContext
> => {
  const mutationKey = ['refreshAssetContent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshAssetContent>>,
    {
      organization: string;
      workspace: string;
      asset: string;
      data: AssetServiceRefreshAssetContentBody;
    }
  > = props => {
    const { organization, workspace, asset, data } = props ?? {};

    return refreshAssetContent(
      organization,
      workspace,
      asset,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshAssetContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshAssetContent>>
>;
export type RefreshAssetContentMutationBody =
  AssetServiceRefreshAssetContentBody;
export type RefreshAssetContentMutationError = AxiosError<RpcStatus>;

/**
 * @summary Refresh the asset's cached content fields — size_bytes, mime_type,
update_time — from its backing file.
 */
export const useRefreshAssetContent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshAssetContent>>,
      TError,
      {
        organization: string;
        workspace: string;
        asset: string;
        data: AssetServiceRefreshAssetContentBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refreshAssetContent>>,
  TError,
  {
    organization: string;
    workspace: string;
    asset: string;
    data: AssetServiceRefreshAssetContentBody;
  },
  TContext
> => {
  const mutationOptions = getRefreshAssetContentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete multiple assets in a single best-effort call.
Each asset is deleted independently; per-item results are returned.
 */
export const batchDeleteAssets = (
  organization: string,
  workspace: string,
  assetServiceBatchDeleteAssetsBody: AssetServiceBatchDeleteAssetsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchDeleteAssetsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets:batchDelete`,
    assetServiceBatchDeleteAssetsBody,
    options,
  );
};

export const getBatchDeleteAssetsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchDeleteAssets>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AssetServiceBatchDeleteAssetsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchDeleteAssets>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetServiceBatchDeleteAssetsBody;
  },
  TContext
> => {
  const mutationKey = ['batchDeleteAssets'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchDeleteAssets>>,
    {
      organization: string;
      workspace: string;
      data: AssetServiceBatchDeleteAssetsBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return batchDeleteAssets(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchDeleteAssetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchDeleteAssets>>
>;
export type BatchDeleteAssetsMutationBody = AssetServiceBatchDeleteAssetsBody;
export type BatchDeleteAssetsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Delete multiple assets in a single best-effort call.
Each asset is deleted independently; per-item results are returned.
 */
export const useBatchDeleteAssets = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchDeleteAssets>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AssetServiceBatchDeleteAssetsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchDeleteAssets>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetServiceBatchDeleteAssetsBody;
  },
  TContext
> => {
  const mutationOptions = getBatchDeleteAssetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Build a ZIP archive of multiple assets and return a presigned download URL.
Assets are collected independently; per-item errors are recorded without
failing the overall request.
 */
export const batchDownloadAssets = (
  organization: string,
  workspace: string,
  assetServiceBatchDownloadAssetsBody: AssetServiceBatchDownloadAssetsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchDownloadAssetsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets:batchDownload`,
    assetServiceBatchDownloadAssetsBody,
    options,
  );
};

export const getBatchDownloadAssetsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchDownloadAssets>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AssetServiceBatchDownloadAssetsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchDownloadAssets>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetServiceBatchDownloadAssetsBody;
  },
  TContext
> => {
  const mutationKey = ['batchDownloadAssets'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchDownloadAssets>>,
    {
      organization: string;
      workspace: string;
      data: AssetServiceBatchDownloadAssetsBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return batchDownloadAssets(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchDownloadAssetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchDownloadAssets>>
>;
export type BatchDownloadAssetsMutationBody =
  AssetServiceBatchDownloadAssetsBody;
export type BatchDownloadAssetsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Build a ZIP archive of multiple assets and return a presigned download URL.
Assets are collected independently; per-item errors are recorded without
failing the overall request.
 */
export const useBatchDownloadAssets = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchDownloadAssets>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AssetServiceBatchDownloadAssetsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchDownloadAssets>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetServiceBatchDownloadAssetsBody;
  },
  TContext
> => {
  const mutationOptions = getBatchDownloadAssetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Duplicate multiple assets in a single best-effort call.
Each asset is duplicated independently; per-item results are returned.
On success, the result name is the resource name of the new copy.
 */
export const batchDuplicateAssets = (
  organization: string,
  workspace: string,
  assetServiceBatchDuplicateAssetsBody: AssetServiceBatchDuplicateAssetsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchDuplicateAssetsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets:batchDuplicate`,
    assetServiceBatchDuplicateAssetsBody,
    options,
  );
};

export const getBatchDuplicateAssetsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchDuplicateAssets>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AssetServiceBatchDuplicateAssetsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchDuplicateAssets>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetServiceBatchDuplicateAssetsBody;
  },
  TContext
> => {
  const mutationKey = ['batchDuplicateAssets'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchDuplicateAssets>>,
    {
      organization: string;
      workspace: string;
      data: AssetServiceBatchDuplicateAssetsBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return batchDuplicateAssets(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchDuplicateAssetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchDuplicateAssets>>
>;
export type BatchDuplicateAssetsMutationBody =
  AssetServiceBatchDuplicateAssetsBody;
export type BatchDuplicateAssetsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Duplicate multiple assets in a single best-effort call.
Each asset is duplicated independently; per-item results are returned.
On success, the result name is the resource name of the new copy.
 */
export const useBatchDuplicateAssets = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchDuplicateAssets>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AssetServiceBatchDuplicateAssetsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchDuplicateAssets>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetServiceBatchDuplicateAssetsBody;
  },
  TContext
> => {
  const mutationOptions = getBatchDuplicateAssetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Move multiple assets to a destination folder in a single best-effort call.
Each asset is moved independently; per-item results are returned.
 */
export const batchMoveAssets = (
  organization: string,
  workspace: string,
  assetServiceBatchMoveAssetsBody: AssetServiceBatchMoveAssetsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchMoveAssetsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets:batchMove`,
    assetServiceBatchMoveAssetsBody,
    options,
  );
};

export const getBatchMoveAssetsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchMoveAssets>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AssetServiceBatchMoveAssetsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchMoveAssets>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetServiceBatchMoveAssetsBody;
  },
  TContext
> => {
  const mutationKey = ['batchMoveAssets'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchMoveAssets>>,
    {
      organization: string;
      workspace: string;
      data: AssetServiceBatchMoveAssetsBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return batchMoveAssets(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchMoveAssetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchMoveAssets>>
>;
export type BatchMoveAssetsMutationBody = AssetServiceBatchMoveAssetsBody;
export type BatchMoveAssetsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Move multiple assets to a destination folder in a single best-effort call.
Each asset is moved independently; per-item results are returned.
 */
export const useBatchMoveAssets = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchMoveAssets>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AssetServiceBatchMoveAssetsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchMoveAssets>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetServiceBatchMoveAssetsBody;
  },
  TContext
> => {
  const mutationOptions = getBatchMoveAssetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all unique tags in use across all assets in a workspace.
Returns a deduplicated, sorted list of tag strings. Tags are compared
case-insensitively, so each tag appears once regardless of case.
Used to populate the Tags filter dropdown in the Library UI.
 */
export const listWorkspaceTags = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListWorkspaceTagsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets:tags`,
    options,
  );
};

export const getListWorkspaceTagsQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets:tags`,
  ] as const;
};

export const getListWorkspaceTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaceTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceTags>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListWorkspaceTagsQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceTags>>
  > = ({ signal }) =>
    listWorkspaceTags(organization, workspace, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWorkspaceTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceTags>>
>;
export type ListWorkspaceTagsQueryError = AxiosError<RpcStatus>;

export function useListWorkspaceTags<
  TData = Awaited<ReturnType<typeof listWorkspaceTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceTags>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaceTags>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaceTags>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspaceTags<
  TData = Awaited<ReturnType<typeof listWorkspaceTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceTags>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaceTags>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaceTags>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspaceTags<
  TData = Awaited<ReturnType<typeof listWorkspaceTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceTags>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all unique tags in use across all assets in a workspace.
Returns a deduplicated, sorted list of tag strings. Tags are compared
case-insensitively, so each tag appears once regardless of case.
Used to populate the Tags filter dropdown in the Library UI.
 */

export function useListWorkspaceTags<
  TData = Awaited<ReturnType<typeof listWorkspaceTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceTags>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListWorkspaceTagsQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List collections in a workspace.
 */
export const listCollections = (
  organization: string,
  workspace: string,
  params?: ListCollectionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListCollectionsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListCollectionsQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListCollectionsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListCollectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCollections>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListCollectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCollections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCollectionsQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCollections>>> = ({
    signal,
  }) =>
    listCollections(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCollections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCollectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCollections>>
>;
export type ListCollectionsQueryError = AxiosError<RpcStatus>;

export function useListCollections<
  TData = Awaited<ReturnType<typeof listCollections>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListCollectionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCollections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCollections>>,
          TError,
          Awaited<ReturnType<typeof listCollections>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCollections<
  TData = Awaited<ReturnType<typeof listCollections>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListCollectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCollections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCollections>>,
          TError,
          Awaited<ReturnType<typeof listCollections>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCollections<
  TData = Awaited<ReturnType<typeof listCollections>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListCollectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCollections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List collections in a workspace.
 */

export function useListCollections<
  TData = Awaited<ReturnType<typeof listCollections>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListCollectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCollections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListCollectionsQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a collection in a workspace.
body is "*" (not "collection") so the sibling `schema` input is bound too.
 */
export const createCollection = (
  organization: string,
  workspace: string,
  collectionsServiceCreateCollectionBody: CollectionsServiceCreateCollectionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Collection>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections`,
    collectionsServiceCreateCollectionBody,
    options,
  );
};

export const getCreateCollectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCollection>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: CollectionsServiceCreateCollectionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCollection>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: CollectionsServiceCreateCollectionBody;
  },
  TContext
> => {
  const mutationKey = ['createCollection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCollection>>,
    {
      organization: string;
      workspace: string;
      data: CollectionsServiceCreateCollectionBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return createCollection(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCollection>>
>;
export type CreateCollectionMutationBody =
  CollectionsServiceCreateCollectionBody;
export type CreateCollectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Create a collection in a workspace.
body is "*" (not "collection") so the sibling `schema` input is bound too.
 */
export const useCreateCollection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCollection>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: CollectionsServiceCreateCollectionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCollection>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: CollectionsServiceCreateCollectionBody;
  },
  TContext
> => {
  const mutationOptions = getCreateCollectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get collection metadata by resource name.
 */
export const getCollection = (
  organization: string,
  workspace: string,
  collection: string,
  params?: GetCollectionParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Collection>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetCollectionQueryKey = (
  organization?: string,
  workspace?: string,
  collection?: string,
  params?: GetCollectionParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCollectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getCollection>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  params?: GetCollectionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCollection>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionQueryKey(organization, workspace, collection, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCollection>>> = ({
    signal,
  }) =>
    getCollection(organization, workspace, collection, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && collection),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCollectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCollection>>
>;
export type GetCollectionQueryError = AxiosError<RpcStatus>;

export function useGetCollection<
  TData = Awaited<ReturnType<typeof getCollection>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  params: undefined | GetCollectionParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCollection>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollection>>,
          TError,
          Awaited<ReturnType<typeof getCollection>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCollection<
  TData = Awaited<ReturnType<typeof getCollection>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  params?: GetCollectionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCollection>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollection>>,
          TError,
          Awaited<ReturnType<typeof getCollection>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCollection<
  TData = Awaited<ReturnType<typeof getCollection>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  params?: GetCollectionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCollection>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get collection metadata by resource name.
 */

export function useGetCollection<
  TData = Awaited<ReturnType<typeof getCollection>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  params?: GetCollectionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCollection>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCollectionQueryOptions(
    organization,
    workspace,
    collection,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete a collection.
 */
export const deleteCollection = (
  organization: string,
  workspace: string,
  collection: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteCollection200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}`,
    options,
  );
};

export const getDeleteCollectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCollection>>,
    TError,
    { organization: string; workspace: string; collection: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCollection>>,
  TError,
  { organization: string; workspace: string; collection: string },
  TContext
> => {
  const mutationKey = ['deleteCollection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCollection>>,
    { organization: string; workspace: string; collection: string }
  > = props => {
    const { organization, workspace, collection } = props ?? {};

    return deleteCollection(organization, workspace, collection, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCollection>>
>;

export type DeleteCollectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Delete a collection.
 */
export const useDeleteCollection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCollection>>,
      TError,
      { organization: string; workspace: string; collection: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCollection>>,
  TError,
  { organization: string; workspace: string; collection: string },
  TContext
> => {
  const mutationOptions = getDeleteCollectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update a collection's mutable fields (display_name, description, tags).
Include "tags" in update_mask to replace or clear tags (see UpdateCollectionRequest).
To edit the schema, use UpdateCollectionSchema (whole schema) or the
field-level RPCs (AddCollectionField / UpdateCollectionField / DeleteCollectionField).
 */
export const updateCollection = (
  organization: string,
  workspace: string,
  collection: string,
  updateCollectionBody: NonReadonly<UpdateCollectionBody>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Collection>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}`,
    updateCollectionBody,
    options,
  );
};

export const getUpdateCollectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCollection>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: NonReadonly<UpdateCollectionBody>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCollection>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: NonReadonly<UpdateCollectionBody>;
  },
  TContext
> => {
  const mutationKey = ['updateCollection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCollection>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: NonReadonly<UpdateCollectionBody>;
    }
  > = props => {
    const { organization, workspace, collection, data } = props ?? {};

    return updateCollection(
      organization,
      workspace,
      collection,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCollection>>
>;
export type UpdateCollectionMutationBody = NonReadonly<UpdateCollectionBody>;
export type UpdateCollectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Update a collection's mutable fields (display_name, description, tags).
Include "tags" in update_mask to replace or clear tags (see UpdateCollectionRequest).
To edit the schema, use UpdateCollectionSchema (whole schema) or the
field-level RPCs (AddCollectionField / UpdateCollectionField / DeleteCollectionField).
 */
export const useUpdateCollection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCollection>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        data: NonReadonly<UpdateCollectionBody>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCollection>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: NonReadonly<UpdateCollectionBody>;
  },
  TContext
> => {
  const mutationOptions = getUpdateCollectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Insert a new row into a collection.
Server assigns __row_id__ to the new row.
 */
export const insertCollectionRow = (
  organization: string,
  workspace: string,
  collection: string,
  insertCollectionRowBody: InsertCollectionRowBody,
  params?: InsertCollectionRowParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1InsertCollectionRowResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}/rows`,
    insertCollectionRowBody,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getInsertCollectionRowMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof insertCollectionRow>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: InsertCollectionRowBody;
      params?: InsertCollectionRowParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof insertCollectionRow>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: InsertCollectionRowBody;
    params?: InsertCollectionRowParams;
  },
  TContext
> => {
  const mutationKey = ['insertCollectionRow'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof insertCollectionRow>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: InsertCollectionRowBody;
      params?: InsertCollectionRowParams;
    }
  > = props => {
    const { organization, workspace, collection, data, params } = props ?? {};

    return insertCollectionRow(
      organization,
      workspace,
      collection,
      data,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type InsertCollectionRowMutationResult = NonNullable<
  Awaited<ReturnType<typeof insertCollectionRow>>
>;
export type InsertCollectionRowMutationBody = InsertCollectionRowBody;
export type InsertCollectionRowMutationError = AxiosError<RpcStatus>;

/**
 * @summary Insert a new row into a collection.
Server assigns __row_id__ to the new row.
 */
export const useInsertCollectionRow = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof insertCollectionRow>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        data: InsertCollectionRowBody;
        params?: InsertCollectionRowParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof insertCollectionRow>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: InsertCollectionRowBody;
    params?: InsertCollectionRowParams;
  },
  TContext
> => {
  const mutationOptions = getInsertCollectionRowMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a single row by row_id.
 */
export const getCollectionRow = (
  organization: string,
  workspace: string,
  collection: string,
  row: string,
  params?: GetCollectionRowParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetCollectionRowResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}/rows/${row}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetCollectionRowQueryKey = (
  organization?: string,
  workspace?: string,
  collection?: string,
  row?: string,
  params?: GetCollectionRowParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}/rows/${row}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCollectionRowQueryOptions = <
  TData = Awaited<ReturnType<typeof getCollectionRow>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  row: string,
  params?: GetCollectionRowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionRow>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionRowQueryKey(
      organization,
      workspace,
      collection,
      row,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectionRow>>
  > = ({ signal }) =>
    getCollectionRow(organization, workspace, collection, row, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && collection && row),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollectionRow>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCollectionRowQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCollectionRow>>
>;
export type GetCollectionRowQueryError = AxiosError<RpcStatus>;

export function useGetCollectionRow<
  TData = Awaited<ReturnType<typeof getCollectionRow>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  row: string,
  params: undefined | GetCollectionRowParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionRow>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionRow>>,
          TError,
          Awaited<ReturnType<typeof getCollectionRow>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCollectionRow<
  TData = Awaited<ReturnType<typeof getCollectionRow>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  row: string,
  params?: GetCollectionRowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionRow>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionRow>>,
          TError,
          Awaited<ReturnType<typeof getCollectionRow>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCollectionRow<
  TData = Awaited<ReturnType<typeof getCollectionRow>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  row: string,
  params?: GetCollectionRowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionRow>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single row by row_id.
 */

export function useGetCollectionRow<
  TData = Awaited<ReturnType<typeof getCollectionRow>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  row: string,
  params?: GetCollectionRowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionRow>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCollectionRowQueryOptions(
    organization,
    workspace,
    collection,
    row,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete a single row by row_id.
 */
export const deleteCollectionRow = (
  organization: string,
  workspace: string,
  collection: string,
  row: string,
  params?: DeleteCollectionRowParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteCollectionRow200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}/rows/${row}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteCollectionRowMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCollectionRow>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      row: string;
      params?: DeleteCollectionRowParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCollectionRow>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    row: string;
    params?: DeleteCollectionRowParams;
  },
  TContext
> => {
  const mutationKey = ['deleteCollectionRow'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCollectionRow>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      row: string;
      params?: DeleteCollectionRowParams;
    }
  > = props => {
    const { organization, workspace, collection, row, params } = props ?? {};

    return deleteCollectionRow(
      organization,
      workspace,
      collection,
      row,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCollectionRowMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCollectionRow>>
>;

export type DeleteCollectionRowMutationError = AxiosError<RpcStatus>;

/**
 * @summary Delete a single row by row_id.
 */
export const useDeleteCollectionRow = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCollectionRow>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        row: string;
        params?: DeleteCollectionRowParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCollectionRow>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    row: string;
    params?: DeleteCollectionRowParams;
  },
  TContext
> => {
  const mutationOptions = getDeleteCollectionRowMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update an existing row by row_id.
 */
export const updateCollectionRow = (
  organization: string,
  workspace: string,
  collection: string,
  row: string,
  updateCollectionRowBody: UpdateCollectionRowBody,
  params?: UpdateCollectionRowParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UpdateCollectionRowResponse>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}/rows/${row}`,
    updateCollectionRowBody,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getUpdateCollectionRowMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCollectionRow>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      row: string;
      data: UpdateCollectionRowBody;
      params?: UpdateCollectionRowParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCollectionRow>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    row: string;
    data: UpdateCollectionRowBody;
    params?: UpdateCollectionRowParams;
  },
  TContext
> => {
  const mutationKey = ['updateCollectionRow'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCollectionRow>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      row: string;
      data: UpdateCollectionRowBody;
      params?: UpdateCollectionRowParams;
    }
  > = props => {
    const { organization, workspace, collection, row, data, params } =
      props ?? {};

    return updateCollectionRow(
      organization,
      workspace,
      collection,
      row,
      data,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCollectionRowMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCollectionRow>>
>;
export type UpdateCollectionRowMutationBody = UpdateCollectionRowBody;
export type UpdateCollectionRowMutationError = AxiosError<RpcStatus>;

/**
 * @summary Update an existing row by row_id.
 */
export const useUpdateCollectionRow = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCollectionRow>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        row: string;
        data: UpdateCollectionRowBody;
        params?: UpdateCollectionRowParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCollectionRow>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    row: string;
    data: UpdateCollectionRowBody;
    params?: UpdateCollectionRowParams;
  },
  TContext
> => {
  const mutationOptions = getUpdateCollectionRowMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete multiple rows by __row_id__ in a single atomic call.
Returns the number of rows deleted.
 */
export const batchDeleteCollectionRows = (
  organization: string,
  workspace: string,
  collection: string,
  collectionRowsServiceBatchDeleteCollectionRowsBody: CollectionRowsServiceBatchDeleteCollectionRowsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchDeleteCollectionRowsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}/rows:batchDelete`,
    collectionRowsServiceBatchDeleteCollectionRowsBody,
    options,
  );
};

export const getBatchDeleteCollectionRowsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchDeleteCollectionRows>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionRowsServiceBatchDeleteCollectionRowsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchDeleteCollectionRows>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionRowsServiceBatchDeleteCollectionRowsBody;
  },
  TContext
> => {
  const mutationKey = ['batchDeleteCollectionRows'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchDeleteCollectionRows>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionRowsServiceBatchDeleteCollectionRowsBody;
    }
  > = props => {
    const { organization, workspace, collection, data } = props ?? {};

    return batchDeleteCollectionRows(
      organization,
      workspace,
      collection,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchDeleteCollectionRowsMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchDeleteCollectionRows>>
>;
export type BatchDeleteCollectionRowsMutationBody =
  CollectionRowsServiceBatchDeleteCollectionRowsBody;
export type BatchDeleteCollectionRowsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Delete multiple rows by __row_id__ in a single atomic call.
Returns the number of rows deleted.
 */
export const useBatchDeleteCollectionRows = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchDeleteCollectionRows>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        data: CollectionRowsServiceBatchDeleteCollectionRowsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchDeleteCollectionRows>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionRowsServiceBatchDeleteCollectionRowsBody;
  },
  TContext
> => {
  const mutationOptions = getBatchDeleteCollectionRowsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Insert multiple rows in a single atomic call.
Returns the inserted rows with their server-assigned __row_id__.
 */
export const batchInsertCollectionRows = (
  organization: string,
  workspace: string,
  collection: string,
  collectionRowsServiceBatchInsertCollectionRowsBody: CollectionRowsServiceBatchInsertCollectionRowsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchInsertCollectionRowsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}/rows:batchInsert`,
    collectionRowsServiceBatchInsertCollectionRowsBody,
    options,
  );
};

export const getBatchInsertCollectionRowsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchInsertCollectionRows>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionRowsServiceBatchInsertCollectionRowsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchInsertCollectionRows>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionRowsServiceBatchInsertCollectionRowsBody;
  },
  TContext
> => {
  const mutationKey = ['batchInsertCollectionRows'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchInsertCollectionRows>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionRowsServiceBatchInsertCollectionRowsBody;
    }
  > = props => {
    const { organization, workspace, collection, data } = props ?? {};

    return batchInsertCollectionRows(
      organization,
      workspace,
      collection,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchInsertCollectionRowsMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchInsertCollectionRows>>
>;
export type BatchInsertCollectionRowsMutationBody =
  CollectionRowsServiceBatchInsertCollectionRowsBody;
export type BatchInsertCollectionRowsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Insert multiple rows in a single atomic call.
Returns the inserted rows with their server-assigned __row_id__.
 */
export const useBatchInsertCollectionRows = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchInsertCollectionRows>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        data: CollectionRowsServiceBatchInsertCollectionRowsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchInsertCollectionRows>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionRowsServiceBatchInsertCollectionRowsBody;
  },
  TContext
> => {
  const mutationOptions = getBatchInsertCollectionRowsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Export all rows of a collection as a CSV file. Generates the CSV
server-side, stores it, and returns a presigned download URL.
 */
export const exportCollection = (
  organization: string,
  workspace: string,
  collection: string,
  collectionRowsServiceExportCollectionBody: CollectionRowsServiceExportCollectionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ExportCollectionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}/rows:exportCsv`,
    collectionRowsServiceExportCollectionBody,
    options,
  );
};

export const getExportCollectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportCollection>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionRowsServiceExportCollectionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportCollection>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionRowsServiceExportCollectionBody;
  },
  TContext
> => {
  const mutationKey = ['exportCollection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportCollection>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionRowsServiceExportCollectionBody;
    }
  > = props => {
    const { organization, workspace, collection, data } = props ?? {};

    return exportCollection(
      organization,
      workspace,
      collection,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportCollection>>
>;
export type ExportCollectionMutationBody =
  CollectionRowsServiceExportCollectionBody;
export type ExportCollectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Export all rows of a collection as a CSV file. Generates the CSV
server-side, stores it, and returns a presigned download URL.
 */
export const useExportCollection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof exportCollection>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        data: CollectionRowsServiceExportCollectionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof exportCollection>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionRowsServiceExportCollectionBody;
  },
  TContext
> => {
  const mutationOptions = getExportCollectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The caller first uploads the source file to Bishop (e.g. via
FilesHttpService.UploadFile) and passes its Bishop file URL as
`source_uri`. The service downloads the file, parses it (CSV), and bulk
inserts the parsed rows. When the target collection has no schema yet, the
schema is inferred from the file's columns and stored as a new version.
 * @summary Import rows into a collection from a previously-uploaded Bishop file.
 */
export const importCollection = (
  organization: string,
  workspace: string,
  collection: string,
  collectionRowsServiceImportCollectionBody: CollectionRowsServiceImportCollectionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ImportCollectionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}/rows:importCsv`,
    collectionRowsServiceImportCollectionBody,
    options,
  );
};

export const getImportCollectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importCollection>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionRowsServiceImportCollectionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importCollection>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionRowsServiceImportCollectionBody;
  },
  TContext
> => {
  const mutationKey = ['importCollection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importCollection>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionRowsServiceImportCollectionBody;
    }
  > = props => {
    const { organization, workspace, collection, data } = props ?? {};

    return importCollection(
      organization,
      workspace,
      collection,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof importCollection>>
>;
export type ImportCollectionMutationBody =
  CollectionRowsServiceImportCollectionBody;
export type ImportCollectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Import rows into a collection from a previously-uploaded Bishop file.
 */
export const useImportCollection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importCollection>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        data: CollectionRowsServiceImportCollectionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof importCollection>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionRowsServiceImportCollectionBody;
  },
  TContext
> => {
  const mutationOptions = getImportCollectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List rows from a collection with pagination and filtering.
 */
export const listCollectionRows = (
  organization: string,
  workspace: string,
  collection: string,
  collectionRowsServiceListCollectionRowsBody: CollectionRowsServiceListCollectionRowsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListCollectionRowsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}/rows:query`,
    collectionRowsServiceListCollectionRowsBody,
    options,
  );
};

export const getListCollectionRowsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listCollectionRows>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionRowsServiceListCollectionRowsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listCollectionRows>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionRowsServiceListCollectionRowsBody;
  },
  TContext
> => {
  const mutationKey = ['listCollectionRows'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listCollectionRows>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionRowsServiceListCollectionRowsBody;
    }
  > = props => {
    const { organization, workspace, collection, data } = props ?? {};

    return listCollectionRows(
      organization,
      workspace,
      collection,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ListCollectionRowsMutationResult = NonNullable<
  Awaited<ReturnType<typeof listCollectionRows>>
>;
export type ListCollectionRowsMutationBody =
  CollectionRowsServiceListCollectionRowsBody;
export type ListCollectionRowsMutationError = AxiosError<RpcStatus>;

/**
 * @summary List rows from a collection with pagination and filtering.
 */
export const useListCollectionRows = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listCollectionRows>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        data: CollectionRowsServiceListCollectionRowsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof listCollectionRows>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionRowsServiceListCollectionRowsBody;
  },
  TContext
> => {
  const mutationOptions = getListCollectionRowsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a collection's current schema for a stage. Defaults to the DRAFT stage.
 */
export const getCollectionSchema = (
  organization: string,
  workspace: string,
  collection: string,
  params?: GetCollectionSchemaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CollectionSchema>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}/schema`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetCollectionSchemaQueryKey = (
  organization?: string,
  workspace?: string,
  collection?: string,
  params?: GetCollectionSchemaParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}/schema`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCollectionSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof getCollectionSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  params?: GetCollectionSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionSchemaQueryKey(organization, workspace, collection, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectionSchema>>
  > = ({ signal }) =>
    getCollectionSchema(organization, workspace, collection, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && collection),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollectionSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCollectionSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCollectionSchema>>
>;
export type GetCollectionSchemaQueryError = AxiosError<RpcStatus>;

export function useGetCollectionSchema<
  TData = Awaited<ReturnType<typeof getCollectionSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  params: undefined | GetCollectionSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionSchema>>,
          TError,
          Awaited<ReturnType<typeof getCollectionSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCollectionSchema<
  TData = Awaited<ReturnType<typeof getCollectionSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  params?: GetCollectionSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionSchema>>,
          TError,
          Awaited<ReturnType<typeof getCollectionSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCollectionSchema<
  TData = Awaited<ReturnType<typeof getCollectionSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  params?: GetCollectionSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a collection's current schema for a stage. Defaults to the DRAFT stage.
 */

export function useGetCollectionSchema<
  TData = Awaited<ReturnType<typeof getCollectionSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  params?: GetCollectionSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCollectionSchemaQueryOptions(
    organization,
    workspace,
    collection,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a single field (column) to a collection's schema.
Creates a new schema version; returns the resulting current schema.
Returns ALREADY_EXISTS if a field with the same name already exists.
 */
export const addCollectionField = (
  organization: string,
  workspace: string,
  collection: string,
  collectionsServiceAddCollectionFieldBody: CollectionsServiceAddCollectionFieldBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CollectionSchema>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}:addField`,
    collectionsServiceAddCollectionFieldBody,
    options,
  );
};

export const getAddCollectionFieldMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addCollectionField>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionsServiceAddCollectionFieldBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addCollectionField>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionsServiceAddCollectionFieldBody;
  },
  TContext
> => {
  const mutationKey = ['addCollectionField'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addCollectionField>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionsServiceAddCollectionFieldBody;
    }
  > = props => {
    const { organization, workspace, collection, data } = props ?? {};

    return addCollectionField(
      organization,
      workspace,
      collection,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AddCollectionFieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof addCollectionField>>
>;
export type AddCollectionFieldMutationBody =
  CollectionsServiceAddCollectionFieldBody;
export type AddCollectionFieldMutationError = AxiosError<RpcStatus>;

/**
 * @summary Add a single field (column) to a collection's schema.
Creates a new schema version; returns the resulting current schema.
Returns ALREADY_EXISTS if a field with the same name already exists.
 */
export const useAddCollectionField = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addCollectionField>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        data: CollectionsServiceAddCollectionFieldBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addCollectionField>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionsServiceAddCollectionFieldBody;
  },
  TContext
> => {
  const mutationOptions = getAddCollectionFieldMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a single field (column) from a collection's schema.
Creates a new schema version; returns the resulting current schema.
Returns NOT_FOUND if the named field does not exist.
 */
export const deleteCollectionField = (
  organization: string,
  workspace: string,
  collection: string,
  collectionsServiceDeleteCollectionFieldBody: CollectionsServiceDeleteCollectionFieldBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CollectionSchema>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}:deleteField`,
    collectionsServiceDeleteCollectionFieldBody,
    options,
  );
};

export const getDeleteCollectionFieldMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCollectionField>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionsServiceDeleteCollectionFieldBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCollectionField>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionsServiceDeleteCollectionFieldBody;
  },
  TContext
> => {
  const mutationKey = ['deleteCollectionField'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCollectionField>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionsServiceDeleteCollectionFieldBody;
    }
  > = props => {
    const { organization, workspace, collection, data } = props ?? {};

    return deleteCollectionField(
      organization,
      workspace,
      collection,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCollectionFieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCollectionField>>
>;
export type DeleteCollectionFieldMutationBody =
  CollectionsServiceDeleteCollectionFieldBody;
export type DeleteCollectionFieldMutationError = AxiosError<RpcStatus>;

/**
 * @summary Delete a single field (column) from a collection's schema.
Creates a new schema version; returns the resulting current schema.
Returns NOT_FOUND if the named field does not exist.
 */
export const useDeleteCollectionField = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCollectionField>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        data: CollectionsServiceDeleteCollectionFieldBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCollectionField>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionsServiceDeleteCollectionFieldBody;
  },
  TContext
> => {
  const mutationOptions = getDeleteCollectionFieldMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Promote the draft stage to published.
 */
export const publishCollection = (
  organization: string,
  workspace: string,
  collection: string,
  collectionsServicePublishCollectionBody: CollectionsServicePublishCollectionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1PublishCollectionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}:publish`,
    collectionsServicePublishCollectionBody,
    options,
  );
};

export const getPublishCollectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishCollection>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionsServicePublishCollectionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publishCollection>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionsServicePublishCollectionBody;
  },
  TContext
> => {
  const mutationKey = ['publishCollection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publishCollection>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionsServicePublishCollectionBody;
    }
  > = props => {
    const { organization, workspace, collection, data } = props ?? {};

    return publishCollection(
      organization,
      workspace,
      collection,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PublishCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof publishCollection>>
>;
export type PublishCollectionMutationBody =
  CollectionsServicePublishCollectionBody;
export type PublishCollectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Promote the draft stage to published.
 */
export const usePublishCollection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publishCollection>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        data: CollectionsServicePublishCollectionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof publishCollection>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionsServicePublishCollectionBody;
  },
  TContext
> => {
  const mutationOptions = getPublishCollectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update a single field (column) in a collection's schema.
Creates a new schema version; returns the resulting current schema.
Returns NOT_FOUND if the named field does not exist.
 */
export const updateCollectionField = (
  organization: string,
  workspace: string,
  collection: string,
  collectionsServiceUpdateCollectionFieldBody: CollectionsServiceUpdateCollectionFieldBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CollectionSchema>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}:updateField`,
    collectionsServiceUpdateCollectionFieldBody,
    options,
  );
};

export const getUpdateCollectionFieldMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCollectionField>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionsServiceUpdateCollectionFieldBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCollectionField>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionsServiceUpdateCollectionFieldBody;
  },
  TContext
> => {
  const mutationKey = ['updateCollectionField'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCollectionField>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionsServiceUpdateCollectionFieldBody;
    }
  > = props => {
    const { organization, workspace, collection, data } = props ?? {};

    return updateCollectionField(
      organization,
      workspace,
      collection,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCollectionFieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCollectionField>>
>;
export type UpdateCollectionFieldMutationBody =
  CollectionsServiceUpdateCollectionFieldBody;
export type UpdateCollectionFieldMutationError = AxiosError<RpcStatus>;

/**
 * @summary Update a single field (column) in a collection's schema.
Creates a new schema version; returns the resulting current schema.
Returns NOT_FOUND if the named field does not exist.
 */
export const useUpdateCollectionField = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCollectionField>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        data: CollectionsServiceUpdateCollectionFieldBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCollectionField>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionsServiceUpdateCollectionFieldBody;
  },
  TContext
> => {
  const mutationOptions = getUpdateCollectionFieldMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Replace a collection's whole schema in one call.
Creates a new schema version; returns the resulting current schema.
The change is gated by the same backward-compatibility check as the
field-level edits (rejects incompatible changes with FAILED_PRECONDITION).
 */
export const updateCollectionSchema = (
  organization: string,
  workspace: string,
  collection: string,
  collectionsServiceUpdateCollectionSchemaBody: CollectionsServiceUpdateCollectionSchemaBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CollectionSchema>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}:updateSchema`,
    collectionsServiceUpdateCollectionSchemaBody,
    options,
  );
};

export const getUpdateCollectionSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCollectionSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionsServiceUpdateCollectionSchemaBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCollectionSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionsServiceUpdateCollectionSchemaBody;
  },
  TContext
> => {
  const mutationKey = ['updateCollectionSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCollectionSchema>>,
    {
      organization: string;
      workspace: string;
      collection: string;
      data: CollectionsServiceUpdateCollectionSchemaBody;
    }
  > = props => {
    const { organization, workspace, collection, data } = props ?? {};

    return updateCollectionSchema(
      organization,
      workspace,
      collection,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCollectionSchemaMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCollectionSchema>>
>;
export type UpdateCollectionSchemaMutationBody =
  CollectionsServiceUpdateCollectionSchemaBody;
export type UpdateCollectionSchemaMutationError = AxiosError<RpcStatus>;

/**
 * @summary Replace a collection's whole schema in one call.
Creates a new schema version; returns the resulting current schema.
The change is gated by the same backward-compatibility check as the
field-level edits (rejects incompatible changes with FAILED_PRECONDITION).
 */
export const useUpdateCollectionSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCollectionSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        collection: string;
        data: CollectionsServiceUpdateCollectionSchemaBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCollectionSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    collection: string;
    data: CollectionsServiceUpdateCollectionSchemaBody;
  },
  TContext
> => {
  const mutationOptions = getUpdateCollectionSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all unique tags in use across all collections in a workspace.
Returns a deduplicated, sorted list of tag strings. Tags are compared
case-insensitively, so each tag appears once regardless of case.
Used to populate the Tags filter dropdown for collections.
 */
export const listCollectionTags = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListCollectionTagsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections:tags`,
    options,
  );
};

export const getListCollectionTagsQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections:tags`,
  ] as const;
};

export const getListCollectionTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCollectionTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCollectionTags>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCollectionTagsQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCollectionTags>>
  > = ({ signal }) =>
    listCollectionTags(organization, workspace, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCollectionTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCollectionTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCollectionTags>>
>;
export type ListCollectionTagsQueryError = AxiosError<RpcStatus>;

export function useListCollectionTags<
  TData = Awaited<ReturnType<typeof listCollectionTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCollectionTags>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCollectionTags>>,
          TError,
          Awaited<ReturnType<typeof listCollectionTags>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCollectionTags<
  TData = Awaited<ReturnType<typeof listCollectionTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCollectionTags>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCollectionTags>>,
          TError,
          Awaited<ReturnType<typeof listCollectionTags>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCollectionTags<
  TData = Awaited<ReturnType<typeof listCollectionTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCollectionTags>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all unique tags in use across all collections in a workspace.
Returns a deduplicated, sorted list of tag strings. Tags are compared
case-insensitively, so each tag appears once regardless of case.
Used to populate the Tags filter dropdown for collections.
 */

export function useListCollectionTags<
  TData = Awaited<ReturnType<typeof listCollectionTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCollectionTags>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListCollectionTagsQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List folders in a workspace. Use parent_folder_name to list children of a folder.
If parent_folder_name is empty, returns root-level folders.
 */
export const listFolders = (
  organization: string,
  workspace: string,
  params?: ListFoldersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListFoldersResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListFoldersQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListFoldersParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListFoldersQueryOptions = <
  TData = Awaited<ReturnType<typeof listFolders>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListFoldersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListFoldersQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFolders>>> = ({
    signal,
  }) =>
    listFolders(organization, workspace, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listFolders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListFoldersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFolders>>
>;
export type ListFoldersQueryError = AxiosError<RpcStatus>;

export function useListFolders<
  TData = Awaited<ReturnType<typeof listFolders>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListFoldersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFolders>>,
          TError,
          Awaited<ReturnType<typeof listFolders>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFolders<
  TData = Awaited<ReturnType<typeof listFolders>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListFoldersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFolders>>,
          TError,
          Awaited<ReturnType<typeof listFolders>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFolders<
  TData = Awaited<ReturnType<typeof listFolders>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListFoldersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List folders in a workspace. Use parent_folder_name to list children of a folder.
If parent_folder_name is empty, returns root-level folders.
 */

export function useListFolders<
  TData = Awaited<ReturnType<typeof listFolders>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListFoldersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListFoldersQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a folder in a workspace. Set folder.parent_folder_name to nest it.
 */
export const createFolder = (
  organization: string,
  workspace: string,
  v1Folder: NonReadonly<V1Folder>,
  params?: CreateFolderParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Folder>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders`,
    v1Folder,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getCreateFolderMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFolder>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: NonReadonly<V1Folder>;
      params?: CreateFolderParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFolder>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: NonReadonly<V1Folder>;
    params?: CreateFolderParams;
  },
  TContext
> => {
  const mutationKey = ['createFolder'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFolder>>,
    {
      organization: string;
      workspace: string;
      data: NonReadonly<V1Folder>;
      params?: CreateFolderParams;
    }
  > = props => {
    const { organization, workspace, data, params } = props ?? {};

    return createFolder(organization, workspace, data, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFolder>>
>;
export type CreateFolderMutationBody = NonReadonly<V1Folder>;
export type CreateFolderMutationError = AxiosError<RpcStatus>;

/**
 * @summary Create a folder in a workspace. Set folder.parent_folder_name to nest it.
 */
export const useCreateFolder = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createFolder>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: NonReadonly<V1Folder>;
        params?: CreateFolderParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createFolder>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: NonReadonly<V1Folder>;
    params?: CreateFolderParams;
  },
  TContext
> => {
  const mutationOptions = getCreateFolderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get folder metadata by resource name.
 */
export const getFolder = (
  organization: string,
  workspace: string,
  folder: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Folder>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders/${folder}`,
    options,
  );
};

export const getGetFolderQueryKey = (
  organization?: string,
  workspace?: string,
  folder?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders/${folder}`,
  ] as const;
};

export const getGetFolderQueryOptions = <
  TData = Awaited<ReturnType<typeof getFolder>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  folder: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFolder>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFolderQueryKey(organization, workspace, folder);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFolder>>> = ({
    signal,
  }) => getFolder(organization, workspace, folder, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && folder),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getFolder>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetFolderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFolder>>
>;
export type GetFolderQueryError = AxiosError<RpcStatus>;

export function useGetFolder<
  TData = Awaited<ReturnType<typeof getFolder>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  folder: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFolder>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFolder>>,
          TError,
          Awaited<ReturnType<typeof getFolder>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFolder<
  TData = Awaited<ReturnType<typeof getFolder>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  folder: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFolder>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFolder>>,
          TError,
          Awaited<ReturnType<typeof getFolder>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFolder<
  TData = Awaited<ReturnType<typeof getFolder>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  folder: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFolder>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get folder metadata by resource name.
 */

export function useGetFolder<
  TData = Awaited<ReturnType<typeof getFolder>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  folder: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFolder>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFolderQueryOptions(
    organization,
    workspace,
    folder,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete a folder. Set force=true to recursively delete all contents.
 */
export const deleteFolder = (
  organization: string,
  workspace: string,
  folder: string,
  params?: DeleteFolderParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteFolder200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders/${folder}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteFolderMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFolder>>,
    TError,
    {
      organization: string;
      workspace: string;
      folder: string;
      params?: DeleteFolderParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFolder>>,
  TError,
  {
    organization: string;
    workspace: string;
    folder: string;
    params?: DeleteFolderParams;
  },
  TContext
> => {
  const mutationKey = ['deleteFolder'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFolder>>,
    {
      organization: string;
      workspace: string;
      folder: string;
      params?: DeleteFolderParams;
    }
  > = props => {
    const { organization, workspace, folder, params } = props ?? {};

    return deleteFolder(organization, workspace, folder, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFolder>>
>;

export type DeleteFolderMutationError = AxiosError<RpcStatus>;

/**
 * @summary Delete a folder. Set force=true to recursively delete all contents.
 */
export const useDeleteFolder = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteFolder>>,
      TError,
      {
        organization: string;
        workspace: string;
        folder: string;
        params?: DeleteFolderParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteFolder>>,
  TError,
  {
    organization: string;
    workspace: string;
    folder: string;
    params?: DeleteFolderParams;
  },
  TContext
> => {
  const mutationOptions = getDeleteFolderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update a folder (rename or move to a different parent).
 */
export const updateFolder = (
  organization: string,
  workspace: string,
  folder: string,
  updateFolderBody: NonReadonly<UpdateFolderBody>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Folder>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders/${folder}`,
    updateFolderBody,
    options,
  );
};

export const getUpdateFolderMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFolder>>,
    TError,
    {
      organization: string;
      workspace: string;
      folder: string;
      data: NonReadonly<UpdateFolderBody>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFolder>>,
  TError,
  {
    organization: string;
    workspace: string;
    folder: string;
    data: NonReadonly<UpdateFolderBody>;
  },
  TContext
> => {
  const mutationKey = ['updateFolder'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFolder>>,
    {
      organization: string;
      workspace: string;
      folder: string;
      data: NonReadonly<UpdateFolderBody>;
    }
  > = props => {
    const { organization, workspace, folder, data } = props ?? {};

    return updateFolder(organization, workspace, folder, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFolder>>
>;
export type UpdateFolderMutationBody = NonReadonly<UpdateFolderBody>;
export type UpdateFolderMutationError = AxiosError<RpcStatus>;

/**
 * @summary Update a folder (rename or move to a different parent).
 */
export const useUpdateFolder = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateFolder>>,
      TError,
      {
        organization: string;
        workspace: string;
        folder: string;
        data: NonReadonly<UpdateFolderBody>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateFolder>>,
  TError,
  {
    organization: string;
    workspace: string;
    folder: string;
    data: NonReadonly<UpdateFolderBody>;
  },
  TContext
> => {
  const mutationOptions = getUpdateFolderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Deep-duplicate a folder (including all descendant folders and assets).
Asset files are copied server-side; no bytes transit the API.
The root copy's display_name is prefixed "Copy of "; descendant names are unchanged.
Returns the root Folder of the newly created subtree.
 */
export const duplicateFolder = (
  organization: string,
  workspace: string,
  folder: string,
  assetFolderServiceDuplicateFolderBody: AssetFolderServiceDuplicateFolderBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Folder>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders/${folder}:duplicate`,
    assetFolderServiceDuplicateFolderBody,
    options,
  );
};

export const getDuplicateFolderMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateFolder>>,
    TError,
    {
      organization: string;
      workspace: string;
      folder: string;
      data: AssetFolderServiceDuplicateFolderBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateFolder>>,
  TError,
  {
    organization: string;
    workspace: string;
    folder: string;
    data: AssetFolderServiceDuplicateFolderBody;
  },
  TContext
> => {
  const mutationKey = ['duplicateFolder'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateFolder>>,
    {
      organization: string;
      workspace: string;
      folder: string;
      data: AssetFolderServiceDuplicateFolderBody;
    }
  > = props => {
    const { organization, workspace, folder, data } = props ?? {};

    return duplicateFolder(organization, workspace, folder, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateFolder>>
>;
export type DuplicateFolderMutationBody = AssetFolderServiceDuplicateFolderBody;
export type DuplicateFolderMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deep-duplicate a folder (including all descendant folders and assets).
Asset files are copied server-side; no bytes transit the API.
The root copy's display_name is prefixed "Copy of "; descendant names are unchanged.
Returns the root Folder of the newly created subtree.
 */
export const useDuplicateFolder = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof duplicateFolder>>,
      TError,
      {
        organization: string;
        workspace: string;
        folder: string;
        data: AssetFolderServiceDuplicateFolderBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof duplicateFolder>>,
  TError,
  {
    organization: string;
    workspace: string;
    folder: string;
    data: AssetFolderServiceDuplicateFolderBody;
  },
  TContext
> => {
  const mutationOptions = getDuplicateFolderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Move a folder to a new parent (reparent). Returns the updated Folder.
Returns FAILED_PRECONDITION if the move would create a cycle.
 */
export const moveFolder = (
  organization: string,
  workspace: string,
  folder: string,
  assetFolderServiceMoveFolderBody: AssetFolderServiceMoveFolderBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Folder>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders/${folder}:move`,
    assetFolderServiceMoveFolderBody,
    options,
  );
};

export const getMoveFolderMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveFolder>>,
    TError,
    {
      organization: string;
      workspace: string;
      folder: string;
      data: AssetFolderServiceMoveFolderBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof moveFolder>>,
  TError,
  {
    organization: string;
    workspace: string;
    folder: string;
    data: AssetFolderServiceMoveFolderBody;
  },
  TContext
> => {
  const mutationKey = ['moveFolder'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof moveFolder>>,
    {
      organization: string;
      workspace: string;
      folder: string;
      data: AssetFolderServiceMoveFolderBody;
    }
  > = props => {
    const { organization, workspace, folder, data } = props ?? {};

    return moveFolder(organization, workspace, folder, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MoveFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof moveFolder>>
>;
export type MoveFolderMutationBody = AssetFolderServiceMoveFolderBody;
export type MoveFolderMutationError = AxiosError<RpcStatus>;

/**
 * @summary Move a folder to a new parent (reparent). Returns the updated Folder.
Returns FAILED_PRECONDITION if the move would create a cycle.
 */
export const useMoveFolder = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof moveFolder>>,
      TError,
      {
        organization: string;
        workspace: string;
        folder: string;
        data: AssetFolderServiceMoveFolderBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof moveFolder>>,
  TError,
  {
    organization: string;
    workspace: string;
    folder: string;
    data: AssetFolderServiceMoveFolderBody;
  },
  TContext
> => {
  const mutationOptions = getMoveFolderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete multiple folders in a single best-effort call.
Each folder is deleted independently; per-item results are returned.
 */
export const batchDeleteFolders = (
  organization: string,
  workspace: string,
  assetFolderServiceBatchDeleteFoldersBody: AssetFolderServiceBatchDeleteFoldersBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchDeleteFoldersResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders:batchDelete`,
    assetFolderServiceBatchDeleteFoldersBody,
    options,
  );
};

export const getBatchDeleteFoldersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchDeleteFolders>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AssetFolderServiceBatchDeleteFoldersBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchDeleteFolders>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetFolderServiceBatchDeleteFoldersBody;
  },
  TContext
> => {
  const mutationKey = ['batchDeleteFolders'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchDeleteFolders>>,
    {
      organization: string;
      workspace: string;
      data: AssetFolderServiceBatchDeleteFoldersBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return batchDeleteFolders(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchDeleteFoldersMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchDeleteFolders>>
>;
export type BatchDeleteFoldersMutationBody =
  AssetFolderServiceBatchDeleteFoldersBody;
export type BatchDeleteFoldersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Delete multiple folders in a single best-effort call.
Each folder is deleted independently; per-item results are returned.
 */
export const useBatchDeleteFolders = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchDeleteFolders>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AssetFolderServiceBatchDeleteFoldersBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchDeleteFolders>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetFolderServiceBatchDeleteFoldersBody;
  },
  TContext
> => {
  const mutationOptions = getBatchDeleteFoldersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Build a ZIP archive of multiple folders (preserving relative structure)
and return a presigned download URL. Folders are processed independently;
per-item errors are recorded without failing the overall request.
 */
export const batchDownloadFolders = (
  organization: string,
  workspace: string,
  assetFolderServiceBatchDownloadFoldersBody: AssetFolderServiceBatchDownloadFoldersBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchDownloadFoldersResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders:batchDownload`,
    assetFolderServiceBatchDownloadFoldersBody,
    options,
  );
};

export const getBatchDownloadFoldersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchDownloadFolders>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AssetFolderServiceBatchDownloadFoldersBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchDownloadFolders>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetFolderServiceBatchDownloadFoldersBody;
  },
  TContext
> => {
  const mutationKey = ['batchDownloadFolders'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchDownloadFolders>>,
    {
      organization: string;
      workspace: string;
      data: AssetFolderServiceBatchDownloadFoldersBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return batchDownloadFolders(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchDownloadFoldersMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchDownloadFolders>>
>;
export type BatchDownloadFoldersMutationBody =
  AssetFolderServiceBatchDownloadFoldersBody;
export type BatchDownloadFoldersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Build a ZIP archive of multiple folders (preserving relative structure)
and return a presigned download URL. Folders are processed independently;
per-item errors are recorded without failing the overall request.
 */
export const useBatchDownloadFolders = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchDownloadFolders>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AssetFolderServiceBatchDownloadFoldersBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchDownloadFolders>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetFolderServiceBatchDownloadFoldersBody;
  },
  TContext
> => {
  const mutationOptions = getBatchDownloadFoldersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Deep-duplicate multiple folders in a single best-effort call.
Each folder (and its entire subtree) is duplicated independently.
Per-item results are returned; on success the result name is the new root folder.
 */
export const batchDuplicateFolders = (
  organization: string,
  workspace: string,
  assetFolderServiceBatchDuplicateFoldersBody: AssetFolderServiceBatchDuplicateFoldersBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchDuplicateFoldersResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders:batchDuplicate`,
    assetFolderServiceBatchDuplicateFoldersBody,
    options,
  );
};

export const getBatchDuplicateFoldersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchDuplicateFolders>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AssetFolderServiceBatchDuplicateFoldersBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchDuplicateFolders>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetFolderServiceBatchDuplicateFoldersBody;
  },
  TContext
> => {
  const mutationKey = ['batchDuplicateFolders'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchDuplicateFolders>>,
    {
      organization: string;
      workspace: string;
      data: AssetFolderServiceBatchDuplicateFoldersBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return batchDuplicateFolders(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchDuplicateFoldersMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchDuplicateFolders>>
>;
export type BatchDuplicateFoldersMutationBody =
  AssetFolderServiceBatchDuplicateFoldersBody;
export type BatchDuplicateFoldersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deep-duplicate multiple folders in a single best-effort call.
Each folder (and its entire subtree) is duplicated independently.
Per-item results are returned; on success the result name is the new root folder.
 */
export const useBatchDuplicateFolders = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchDuplicateFolders>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AssetFolderServiceBatchDuplicateFoldersBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchDuplicateFolders>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetFolderServiceBatchDuplicateFoldersBody;
  },
  TContext
> => {
  const mutationOptions = getBatchDuplicateFoldersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Move multiple folders to a destination parent in a single best-effort call.
Each folder is moved independently; per-item results are returned.
 */
export const batchMoveFolders = (
  organization: string,
  workspace: string,
  assetFolderServiceBatchMoveFoldersBody: AssetFolderServiceBatchMoveFoldersBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchMoveFoldersResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders:batchMove`,
    assetFolderServiceBatchMoveFoldersBody,
    options,
  );
};

export const getBatchMoveFoldersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchMoveFolders>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AssetFolderServiceBatchMoveFoldersBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchMoveFolders>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetFolderServiceBatchMoveFoldersBody;
  },
  TContext
> => {
  const mutationKey = ['batchMoveFolders'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchMoveFolders>>,
    {
      organization: string;
      workspace: string;
      data: AssetFolderServiceBatchMoveFoldersBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return batchMoveFolders(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchMoveFoldersMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchMoveFolders>>
>;
export type BatchMoveFoldersMutationBody =
  AssetFolderServiceBatchMoveFoldersBody;
export type BatchMoveFoldersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Move multiple folders to a destination parent in a single best-effort call.
Each folder is moved independently; per-item results are returned.
 */
export const useBatchMoveFolders = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchMoveFolders>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AssetFolderServiceBatchMoveFoldersBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchMoveFolders>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AssetFolderServiceBatchMoveFoldersBody;
  },
  TContext
> => {
  const mutationOptions = getBatchMoveFoldersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the full folder tree for a workspace (all folders, nested).
 */
export const getFolderTree = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetFolderTreeResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders:tree`,
    options,
  );
};

export const getGetFolderTreeQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/folders:tree`,
  ] as const;
};

export const getGetFolderTreeQueryOptions = <
  TData = Awaited<ReturnType<typeof getFolderTree>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFolderTree>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFolderTreeQueryKey(organization, workspace);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFolderTree>>> = ({
    signal,
  }) => getFolderTree(organization, workspace, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFolderTree>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFolderTreeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFolderTree>>
>;
export type GetFolderTreeQueryError = AxiosError<RpcStatus>;

export function useGetFolderTree<
  TData = Awaited<ReturnType<typeof getFolderTree>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFolderTree>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFolderTree>>,
          TError,
          Awaited<ReturnType<typeof getFolderTree>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFolderTree<
  TData = Awaited<ReturnType<typeof getFolderTree>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFolderTree>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFolderTree>>,
          TError,
          Awaited<ReturnType<typeof getFolderTree>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFolderTree<
  TData = Awaited<ReturnType<typeof getFolderTree>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFolderTree>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the full folder tree for a workspace (all folders, nested).
 */

export function useGetFolderTree<
  TData = Awaited<ReturnType<typeof getFolderTree>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFolderTree>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFolderTreeQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update multiple rows by __row_id__ in a single atomic call.
Returns the updated rows.
gRPC-only — no REST annotation.
 */
export const batchUpdateCollectionRows = (
  v1BatchUpdateCollectionRowsRequest: V1BatchUpdateCollectionRowsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchUpdateCollectionRowsResponse>> => {
  return axios.default.post(
    `/bishop.collections.v1.CollectionRowsService/BatchUpdateCollectionRows`,
    v1BatchUpdateCollectionRowsRequest,
    options,
  );
};

export const getBatchUpdateCollectionRowsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchUpdateCollectionRows>>,
    TError,
    { data: V1BatchUpdateCollectionRowsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchUpdateCollectionRows>>,
  TError,
  { data: V1BatchUpdateCollectionRowsRequest },
  TContext
> => {
  const mutationKey = ['batchUpdateCollectionRows'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchUpdateCollectionRows>>,
    { data: V1BatchUpdateCollectionRowsRequest }
  > = props => {
    const { data } = props ?? {};

    return batchUpdateCollectionRows(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchUpdateCollectionRowsMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchUpdateCollectionRows>>
>;
export type BatchUpdateCollectionRowsMutationBody =
  V1BatchUpdateCollectionRowsRequest;
export type BatchUpdateCollectionRowsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Update multiple rows by __row_id__ in a single atomic call.
Returns the updated rows.
gRPC-only — no REST annotation.
 */
export const useBatchUpdateCollectionRows = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchUpdateCollectionRows>>,
      TError,
      { data: V1BatchUpdateCollectionRowsRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchUpdateCollectionRows>>,
  TError,
  { data: V1BatchUpdateCollectionRowsRequest },
  TContext
> => {
  const mutationOptions = getBatchUpdateCollectionRowsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete every row matching an AIP-160 filter.
Returns the number of rows deleted.
gRPC-only — no REST annotation.
 */
export const deleteCollectionRowsByFilter = (
  v1DeleteCollectionRowsByFilterRequest: V1DeleteCollectionRowsByFilterRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DeleteCollectionRowsByFilterResponse>> => {
  return axios.default.post(
    `/bishop.collections.v1.CollectionRowsService/DeleteCollectionRowsByFilter`,
    v1DeleteCollectionRowsByFilterRequest,
    options,
  );
};

export const getDeleteCollectionRowsByFilterMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCollectionRowsByFilter>>,
    TError,
    { data: V1DeleteCollectionRowsByFilterRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCollectionRowsByFilter>>,
  TError,
  { data: V1DeleteCollectionRowsByFilterRequest },
  TContext
> => {
  const mutationKey = ['deleteCollectionRowsByFilter'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCollectionRowsByFilter>>,
    { data: V1DeleteCollectionRowsByFilterRequest }
  > = props => {
    const { data } = props ?? {};

    return deleteCollectionRowsByFilter(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCollectionRowsByFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCollectionRowsByFilter>>
>;
export type DeleteCollectionRowsByFilterMutationBody =
  V1DeleteCollectionRowsByFilterRequest;
export type DeleteCollectionRowsByFilterMutationError = AxiosError<RpcStatus>;

/**
 * @summary Delete every row matching an AIP-160 filter.
Returns the number of rows deleted.
gRPC-only — no REST annotation.
 */
export const useDeleteCollectionRowsByFilter = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCollectionRowsByFilter>>,
      TError,
      { data: V1DeleteCollectionRowsByFilterRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCollectionRowsByFilter>>,
  TError,
  { data: V1DeleteCollectionRowsByFilterRequest },
  TContext
> => {
  const mutationOptions =
    getDeleteCollectionRowsByFilterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update every row matching an AIP-160 filter with a common set of values.
Returns the number of rows updated.
gRPC-only — no REST annotation.
 */
export const updateCollectionRowsByFilter = (
  v1UpdateCollectionRowsByFilterRequest: V1UpdateCollectionRowsByFilterRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UpdateCollectionRowsByFilterResponse>> => {
  return axios.default.post(
    `/bishop.collections.v1.CollectionRowsService/UpdateCollectionRowsByFilter`,
    v1UpdateCollectionRowsByFilterRequest,
    options,
  );
};

export const getUpdateCollectionRowsByFilterMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCollectionRowsByFilter>>,
    TError,
    { data: V1UpdateCollectionRowsByFilterRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCollectionRowsByFilter>>,
  TError,
  { data: V1UpdateCollectionRowsByFilterRequest },
  TContext
> => {
  const mutationKey = ['updateCollectionRowsByFilter'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCollectionRowsByFilter>>,
    { data: V1UpdateCollectionRowsByFilterRequest }
  > = props => {
    const { data } = props ?? {};

    return updateCollectionRowsByFilter(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCollectionRowsByFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCollectionRowsByFilter>>
>;
export type UpdateCollectionRowsByFilterMutationBody =
  V1UpdateCollectionRowsByFilterRequest;
export type UpdateCollectionRowsByFilterMutationError = AxiosError<RpcStatus>;

/**
 * @summary Update every row matching an AIP-160 filter with a common set of values.
Returns the number of rows updated.
gRPC-only — no REST annotation.
 */
export const useUpdateCollectionRowsByFilter = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCollectionRowsByFilter>>,
      TError,
      { data: V1UpdateCollectionRowsByFilterRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCollectionRowsByFilter>>,
  TError,
  { data: V1UpdateCollectionRowsByFilterRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateCollectionRowsByFilterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
